// Hardware the IT inventory tracks by hand (the "other hardware" tab): items no agent, MDM or
// cloud connector reports, so laptops, mobiles and servers are deliberately absent here.
export const HARDWARE_ASSET_TYPES = {
  MONITOR: 'monitor',
  PRINTER: 'printer',
  MOUSE: 'mouse',
  DOCK: 'dock',
  USB_DRIVE: 'usb_drive',
  SECURITY_KEY: 'security_key',
  OTHER: 'other',
} as const

export type IHardwareAssetType = (typeof HARDWARE_ASSET_TYPES)[keyof typeof HARDWARE_ASSET_TYPES]

// Ordered values backing the `hardware_asset_type` Postgres enum (see src/db/schema/tables/hardwareAssets.ts)
export const HARDWARE_ASSET_TYPE_VALUES = [
  HARDWARE_ASSET_TYPES.MONITOR,
  HARDWARE_ASSET_TYPES.PRINTER,
  HARDWARE_ASSET_TYPES.MOUSE,
  HARDWARE_ASSET_TYPES.DOCK,
  HARDWARE_ASSET_TYPES.USB_DRIVE,
  HARDWARE_ASSET_TYPES.SECURITY_KEY,
  HARDWARE_ASSET_TYPES.OTHER,
] as const

export const HARDWARE_ASSET_STATUSES = {
  IN_USE: 'in_use',
  IN_STOCK: 'in_stock',
  RETIRED: 'retired',
} as const

export type IHardwareAssetStatus = (typeof HARDWARE_ASSET_STATUSES)[keyof typeof HARDWARE_ASSET_STATUSES]

// Ordered values backing the `hardware_asset_status` Postgres enum (see src/db/schema/tables/hardwareAssets.ts)
export const HARDWARE_ASSET_STATUS_VALUES = [
  HARDWARE_ASSET_STATUSES.IN_USE,
  HARDWARE_ASSET_STATUSES.IN_STOCK,
  HARDWARE_ASSET_STATUSES.RETIRED,
] as const
